function MessageReceiverControlRegistrationRequest() {
}

module.exports = MessageReceiverControlRegistrationRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/message-receiver-control-registration-request.js
// module id = 484
// module chunks = 1